import {Component, Input} from '@angular/core';

import { Router, ActivatedRoute, Params } from '@angular/router';


@Component({
  selector: 'app-modal-resolucao',
  template: `
  <div id="modalre" (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal();">&times;</button>
        <h4 class="modal-title">Resolução de Confidencialidade</h4>
          <ng-content select=".app-modal-header"></ng-content>
        </div>
        <div class="modal-body">
            <p style="font-weight: bold;">Confidencialidade e compromisso de não-retaliação</p><br /><br />

<p align="justify" style="padding-left: 0.5cm;">A Faculdade de Medicina da UFRJ tem o compromisso de promover um ambiente de respeito aos direitos humanos. Qualquer alegação de violação de Direitos Humanos quando apresentada à Comissão de Direitos Humanos da Faculdade de Medicina será ouvida, considerada, apurada e poderá levar à medidas educativas, mediação de conflito, e indicação de instalação de comissão de sindicância. Durante o processo de apuração da denúncia ou alegação de violação ou queixa, docentes, discentes, técnicos ou terceirizados poderão ser convocados como testemunhas para o esclarecimento da situação. A Comissão se compromete a manter a confidencialidade das declarações de todos os envolvidos.</p><br />

<p align="justify" style="padding-left: 0.5cm;">A Faculdade de Medicina da UFRJ proíbe (resolução da congregação aprovada em 16/03/2017 - acesse <a target="_blank" href="../../assets/files/resolucao-25-26.pdf">aqui</a>) retaliação contra qualquer pessoa que apresente uma queixa ou alegação ou denúncia, ou que participe de qualquer processo de apuração como testemunha ou que estimule alguém a denunciar ou testemunhar. A retaliação deve ser entendida como uma ação contrária ao respeito aos direitos humanos; portanto inaceitável.</p><br />

<p align="justify" style="padding-left: 0.5cm;">Os membros da Comissão de Direitos Humanos envolvidos no processo de apuração assumem o dever de confidencialidade e sigilo sobre as informações envolvidas na queixa/alegação/denúncia. Os docentes, discentes, técnicos e terceirizados não devem discutir essas informações entre si ou com outras pessoas durante o curso da apuração e devem ser muito cautelosos no uso dessas informações para efeito de exemplo.</p>
            <br />
          <ng-content select=".app-modal-body"></ng-content>
        </div>
        <div class="modal-footer">
            <div class="col-sm-offset-2 col-sm-10">
            <button type="button" class="btn btn-default" (click)="closeModal();">Fechar</button>
            </div>
          <ng-content select=".app-modal-footer"></ng-content>
        </div>
      </div>
    </div>
  </div>
  `,
  styles: [`
    .modal {
      background: rgba(0,0,0,0.6);
    }
  `],
  providers: [

  ]
})
export class ModalResolucaoComponent {

  public visible = false;
  private visibleAnimate = false;


  constructor(private router: Router){
  }

  public show(id): void {

    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);

  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public closeModal(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }


  goBack(resposta: any): void {
     alert(resposta);
     window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/inicio/modalresolucao.component.ts